<script setup lang="ts">
import { GpNavigationItem, GpNavigationItemLink } from '@gportal/uikit';

withDefaults(
  defineProps<{
    to: string | { name: string; params?: Record<string, string>; query?: Record<string, string> };
    icon?: string[] | object;
    label?: string;
    isLinkActive?: boolean;
  }>(),
  {
    label: '',
    icon: undefined,
    linkActive: false,
  },
);
</script>

<template>
  <GpNavigationItem>
    <router-link :to="to" custom v-slot="{ href, navigate, isActive }">
      <slot
        v-bind="{
          href,
          navigate,
          isActive,
          isLinkActive,
        }"
      >
        <GpNavigationItemLink
          class="tw-text-gp-mouse hover:tw-text-gp-mouse-light"
          :href="href"
          :icon="icon"
          :label="label"
          :is-active="isLinkActive || isActive"
          @click="navigate"
        />
      </slot>
    </router-link>
  </GpNavigationItem>
</template>
